import { send } from './requests';

/**
 * @typedef AboutData
 * @property {string} key
 * @property {string} value
 * @property {string} link
 */

const setPageContent = (content, endpoint) =>
  send(`about-list/${endpoint}`, { data: { content }, method: 'PUT' });
const getPageContent = async (endpoint) => (await send(`about-list/${endpoint}`)).data.data.content;

const setAboutPageContent = (content) => setPageContent(content, 'about-page');
const setContactPageContent = (content) => setPageContent(content, 'contact-page');
const setJoinUsPageContent = (content) => setPageContent(content, 'join-us-page');

const getPagePhoto = async (endpoint) => (await send(`about-list/${endpoint}/photo`)).data.data.url;

const setPagePhoto = (file, endpoint) => {
  const formData = new FormData();
  formData.append('file', file);
  return send(`about-list/${endpoint}/photo`, { data: formData, method: 'POST' });
};

const getAboutPagePhoto = () => getPagePhoto('about-page');

const getContactPagePhoto = () => getPagePhoto('contact-page');

const getJoinUsPagePhoto = () => getPagePhoto('join-us-page');

const setAboutPagePhoto = (file) => setPagePhoto(file, 'about-page');

const setContactPagePhoto = (file) => setPagePhoto(file, 'contact-page');

const setJoinUsPagePhoto = (file) => setPagePhoto(file, 'join-us-page');

const getAboutPageContent = async () => getPageContent('about-page');

const getJoinPageContent = async () => getPageContent('join-us-page');

const getContactPageContent = async () => getPageContent('contact-page');
/**
 * @returns {Promise<{lng: number, lat: number}>}
 */
const getGeoData = async () => (await send('about-list/geo')).data.data;
/**
 * @param {number} lat
 * @param {number} lng
 * @returns {Promise<import('axios').AxiosResponse}
 */
const setGeoData = (lat, lng) => send('about-list/geo', { data: { lat, lng }, method: 'PUT' });

/**
 * @returns {Promise<AboutData[]>}
 */
const getContactData = async () => {
  const dataList = (await send('about-list')).data.data;
  return dataList.map((x) => {
    if (x.text) {
      return {
        key: x.key,
        value: x.text,
        link: x.value
      };
    }
    return {
      key: x.key,
      value: x.value
    };
  });
};
/**
 * @param {AboutData[]} dataList
 */
const setContactData = (dataList) => {
  const body = {};
  for (let i = 0; i < dataList.length; i += 1) {
    const data = dataList[i];
    if (data) {
      if (data.link && data.link !== '') body[data.key] = `(${data.value})[${data.link}]`;
      else body[data.key] = data.value;
    }
  }
  return send('about-list/set', { method: 'PUT', data: body });
};

export {
  setAboutPageContent,
  getAboutPageContent,
  getContactPageContent,
  setContactPageContent,
  getGeoData,
  setGeoData,
  getContactData,
  setContactData,
  getAboutPagePhoto,
  getContactPagePhoto,
  setAboutPagePhoto,
  setContactPagePhoto,
  getJoinPageContent,
  setJoinUsPageContent,
  setJoinUsPagePhoto,
  getJoinUsPagePhoto
};
